import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAllParams } from '../../service/utils';

const AccessibilityTabs = ({ id, menu, children, ...params }) => {

    useEffect(() => {
        const tabList = document.querySelector(`#${id}`);
        const tabs = tabList?.querySelectorAll(menu ? '[aria-haspopup="menu"]' : '[role="tab"]');

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            // remove focus from tab's a element
            const a = tab.querySelector('a');
            a?.setAttribute("tabindex", -1);

            tab.addEventListener("click", changeTabs);
        });

        let tabFocus = Array.from(tabs).findIndex(tab => tab.getAttribute("aria-selected") === "true");
        if (tabFocus === -1) tabFocus = 0; // If no tab is selected, start from the first tab
        tabs[tabFocus]?.setAttribute("tabindex", 0); // Ensure the initially focused tab has tabindex 0

        // Enable arrow navigation between tabs in the tab list
        tabList.addEventListener("keydown", (e) => {
            if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowLeft") {
                    tabFocus++;
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                }
                if (e.key === "ArrowRight") {
                    tabFocus--;
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }

                tabs[tabFocus].setAttribute("tabindex", 0);
                setTimeout(() => tabs[tabFocus].focus(), 0);  // !important setTimeout
            }
            if (e.key === 'Enter') {
                e.stopImmediatePropagation();
                e.target.click();
            }
        });

    }, [children]);


    const changeTabs = (e) => {
        const target = e.currentTarget;
        const parent = target.parentNode;
        const grandparent = parent.parentNode;

        parent.querySelectorAll('[aria-selected="true"]').forEach((t) => t.setAttribute("aria-selected", false));
        target.setAttribute("aria-selected", true);

        grandparent.querySelectorAll('[role="tabpanel"]').forEach((p) => p.setAttribute("hidden", true));
        grandparent.parentNode.querySelector(`#${target.getAttribute("aria-controls")}`)?.removeAttribute("hidden");

        target.querySelector('a')?.click();
    }

    // const changeTabsOld = (e) => {
    //     const target = e.target;
    //     if (target.tagName === 'A') return;
    //     const parent = target.parentNode;
    //     const grandparent = parent.parentNode;

    //     // Remove all current selected tabs
    //     parent
    //         .querySelectorAll('[aria-selected="true"]')
    //         .forEach((t) => t.setAttribute("aria-selected", false));

    //     // Set this tab as selected
    //     target.setAttribute("aria-selected", true);

    //     // Hide all tab panels
    //     grandparent
    //         .querySelectorAll('[role="tabpanel"]')
    //         .forEach((p) => p.setAttribute("hidden", true));

    //     // Show the selected panel
    //     grandparent.parentNode
    //         .querySelector(`#${target.getAttribute("aria-controls")}`)
    //         ?.removeAttribute("hidden");

    //     // want trigger a element click
    //     target.querySelector('a')?.click()
    // }

    // Prepare additional props

    const additionalProps = {
        ...getAllParams(params)
    };

    if (!menu) {
        additionalProps.role = "tablist";
    }
    if (Array.isArray(children)) {
        // Wrap children array with a div and apply additional props
        return <div style={{ width: 'inherit', height: 'inherit' }} {...additionalProps}>{children}</div>;
    } else {
        // Ensure children is wrapped in a React element if it's a string
        const childElement = typeof children === 'string' ? <span>{children}</span> : children;
        // Clone the child element with the additional props
        return React.cloneElement(childElement, additionalProps);
    }
};

AccessibilityTabs.propTypes = window.config.developMode ? {
    id: PropTypes.string.isRequired,
} : {};

export default AccessibilityTabs;
